import { useFormContext } from 'react-hook-form';

import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { IBERIA_CARDS_CAMPAIGNS } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/constants/IberiaCardsCampaigns';
import { SALE_POINTS } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/constants/SalePoints';
import { useLastSalePoint } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/hooks/useLastSalePoint';
import { useStandsAgent } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/hooks/useStandsAgent';
import { SalePointAndProductFormData } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/schemas/SalePointAndProduct.schema';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const useSalePointAndProduct = () => {
  const {
    actions: { updateApplicationContext },
  } = useApplicationContext();
  const { onNext } = useApplicationNavigation();
  const { handleSubmit } = useFormContext<SalePointAndProductFormData>();
  const { standsAgent } = useStandsAgent();
  const { saveLastSalePoint } = useLastSalePoint();

  const onSubmit = () => {
    handleSubmit(
      (data) => {
        const salePoint = SALE_POINTS.find(({ id }) => id === data.salePoint);
        const campaign = IBERIA_CARDS_CAMPAIGNS.find(({ id }) => id === data.campaign);

        if (!standsAgent || !salePoint || !campaign) {
          console.error('Incomplete Iberia Cards stands selection', { standsAgent, salePoint, campaign });
          return;
        }

        saveLastSalePoint(salePoint.id);
        updateApplicationContext({ iberiaCardsStandsSelection: { agent: standsAgent, salePoint, campaign } });
        onNext();
      },
    )();
  };

  return {
    onSubmit,
  };
};
